import React, { useState } from 'react';
import { useAuth } from './AuthProvider';
import './UserProfile.css';

const UserProfile = () => {
    const { user, logout, isLoading } = useAuth();
    const [showDropdown, setShowDropdown] = useState(false);

    const handleLogout = async () => {
        try {
            await logout();
        } catch (error) {
            console.error('Logout error:', error);
        }
    };

    const getInitials = (name) => {
        if (!name) return '?';
        return name
            .split(' ')
            .map(word => word.charAt(0))
            .join('')
            .toUpperCase()
            .slice(0, 2);
    };

    return (
        <div className="user-profile">
            <div className="user-welcome">
                <h2>Welcome back, {user?.displayName || 'User'}! 👋</h2>
                <p>Ready to check your snack spending?</p>
            </div>
            
            <div className="user-info-card">
                <div className="user-avatar">
                    {getInitials(user?.displayName)}
                </div>
                
                <div className="user-details">
                    <h3>{user?.displayName}</h3>
                    <p>{user?.email}</p>
                </div>
                
                <div className="user-actions">
                    <button
                        className="dropdown-toggle"
                        onClick={() => setShowDropdown(!showDropdown)}
                        aria-label="User menu"
                    >
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z" stroke="currentColor" strokeWidth="2"/>
                            <path d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z" stroke="currentColor" strokeWidth="2"/>
                            <path d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z" stroke="currentColor" strokeWidth="2"/>
                        </svg>
                    </button>
                    
                    {showDropdown && (
                        <div className="dropdown-menu">
                            <button
                                className="dropdown-item logout-btn"
                                onClick={handleLogout}
                                disabled={isLoading}
                            >
                                {isLoading ? (
                                    <>
                                        <div className="mini-spinner"></div>
                                        <span>Signing out...</span>
                                    </>
                                ) : (
                                    <>
                                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M9 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H9" stroke="currentColor" strokeWidth="2"/>
                                            <path d="M16 17L21 12L16 7" stroke="currentColor" strokeWidth="2"/>
                                            <path d="M21 12H9" stroke="currentColor" strokeWidth="2"/>
                                        </svg>
                                        <span>Sign out</span>
                                    </>
                                )}
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default UserProfile;